// extracted by mini-css-extract-plugin
export default {"container":"Container_container__WU3O3"};